module.exports = __webpack_public_path__ + "img/bnr3.7bbcd7de.png";